import React, { useEffect, useState } from 'react';

import { Box, Divider, Grid, Typography, useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { motion } from 'framer-motion';
import parse from 'html-react-parser';

import StyledJadeSoftTeam from './styles';

//icon jadesoft team
import IconGlassHour from '../../../components/Icons/IconTurnKey/IconGlassHour';
import IconHandClock from '../../../components/Icons/IconTurnKey/IconHandClock';

import IconJadeSoftV2 from '../../../components/Icons/IconJadeSoftV2';

//icon solution
import IconSolution1 from '../../../components/Icons/IconSolution/IconSolution1';
import IconSolution2 from '../../../components/Icons/IconSolution/IconSolution2';
import IconSolution3 from '../../../components/Icons/IconSolution/IconSolution3';
import IconSolution4 from '../../../components/Icons/IconSolution/IconSolution4';
import IconSolution5 from '../../../components/Icons/IconSolution/IconSolution5';
import IconSolution6 from '../../../components/Icons/IconSolution/IconSolution6';
import IconSolution7 from '../../../components/Icons/IconSolution/IconSolution7';
import IconSolution8 from '../../../components/Icons/IconSolution/IconSolution8';

import OnlineCasino from '../../../assets/images/solution/online_casino.png';
import Poker from '../../../assets/images/solution/poker_app.png';
import SportBook from '../../../assets/images/solution/sportsbook.png';
import CarouselMobile from './carousel_mobile';

import { useTranslation } from 'react-i18next';

const TurnKeySolution = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [isTop, setIsTop] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const label = t('turnkey-content-one');
  const labelMobile = t('turnkey-content-one');
  const label2 = t('turnkey-content-two');
  const label3 = t('igamingsolu-desc-desktop');
  const label4 = t('turnkey-content-three');
  const GameIcon = [
    {
      id: 1,
      title: t('turnkey-game-title-one'),
      content: t('turnkey-game-content-one'),
      image: OnlineCasino,
    },
    {
      id: 2,
      title: t('turnkey-game-title-two'),
      content: t('turnkey-game-content-two'),
      image: SportBook,
    },
    {
      id: 3,
      title: t('turnkey-game-title-three'),
      content: t('turnkey-game-content-three'),
      image: Poker,
    },
  ];

  const HourIcon = [
    {
      id: 1,
      content: t('turnkey-hour-content-one'),
      image: <IconGlassHour />,
    },
    {
      id: 2,
      content: t('turnkey-hour-content-two'),
      image: <IconHandClock />,
    },
  ];

  const label1 = t('igamingsolu-title-desktop');
  const label1mobile = t('igamingsolu-title-mobile');

  const iGamingSolutions = [
    {
      id: 1,
      title: t('igamingsolu-title-one'),
      content: t('igamingsolu-content-one'),
      image: <IconSolution1 />,
    },
    {
      id: 2,
      title: t('igamingsolu-title-two'),
      content: t('igamingsolu-content-two'),
      image: <IconSolution2 />,
    },
    {
      id: 3,
      title: t('igamingsolu-title-three'),
      content: t('igamingsolu-content-three'),
      image: <IconSolution3 />,
    },
    {
      id: 4,
      title: t('igamingsolu-title-four'),
      content: t('igamingsolu-content-four'),
      image: <IconSolution4 />,
    },
    {
      id: 5,
      title: t('igamingsolu-title-five'),
      content: t('igamingsolu-content-five'),
      image: <IconSolution5 />,
    },
    {
      id: 6,
      title: t('igamingsolu-title-six'),
      content: t('igamingsolu-content-six'),
      image: <IconSolution6 />,
    },
    {
      id: 7,
      title: t('igamingsolu-title-seven'),
      content: t('igamingsolu-content-seven'),
      image: <IconSolution7 />,
    },
    {
      id: 8,
      title: t('igamingsolu-title-eight'),
      content: t('igamingsolu-content-eight'),
      image: <IconSolution8 />,
    },
  ];

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleScroll = () => {
        const position = window.scrollY;
        if (position === 0) {
          setIsTop(false);
        } else {
          setIsTop(true);
        }
      };

      window.addEventListener('scroll', handleScroll);

      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isTop]);

  return (
    <StyledJadeSoftTeam>
      <Box className="homeBg">
        {/* <img className="bgImage" src={JadeSoftTeamImage} /> */}
        <Box
          sx={{
            textAlign: { xs: 'center', md: 'center' },
            zIndex: 1,
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '40%',
            // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black overlay
            zIndex: 1,
            // padding: '9% 25% 8% 25%',
            [theme.breakpoints.down('lg')]: {
              // padding: '9% 5% 8% 5%',
              // height: '42%',
              height: '50%',
            },
          }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'center' },
              zIndex: 1,
              position: 'relative',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black overlay
              zIndex: 1,
              padding: '5% 0% 10% 0%',
              // backgroundColor: isTop ? '#02b201' : '#acfa4f',
            }}
          >
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: '64px',
                fontWeight: '900',
                lineHeight: '76.38px',
                color: '#000000',
                [theme.breakpoints.down('lg')]: {
                  mt: 5,
                  fontSize: '55px',
                  lineHeight: '65.63px',
                  mb: 1,
                },
              }}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                  },
                }}
              // viewport={{ once: true }}
              >
                {t('turnkey-title')}
              </motion.div>
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                padding: '0 20%',
                [theme.breakpoints.down('lg')]: {
                  padding: '0',
                },
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  lineHeight: 1.8,
                  wordWrap: 'break-word',
                  fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                  fontSize: '20px',
                  mt: 2,
                  lineHeight: '23.87px',
                  color: '#121421',
                  [theme.breakpoints.down('lg')]: {
                    mt: 1,
                    fontSize: '18px',
                    lineHeight: '23.4px',
                    display: 'none',
                  },
                }}
              >
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 100,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0, // Slide in to its original position
                    transition: {
                      duration: 1, // Animation duration
                      delay: 0.8,
                    },
                  }}
                // viewport={{ once: true }}
                >
                  <p>{parse(label)}</p>
                </motion.div>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  lineHeight: 1.8,
                  wordWrap: 'break-word',
                  fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                  fontSize: '20px',
                  mt: 3,
                  lineHeight: '29px',
                  color: '#121421',
                  display: 'none',
                  [theme.breakpoints.down('lg')]: {
                    mt: 1,
                    fontSize: '18px',
                    lineHeight: '23.4px',
                    display: 'flex',
                    padding: '0px 10px',
                  },
                }}
              >
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 100,
                  }}
                  whileInView={{
                    opacity: 1,
                    y: 0, // Slide in to its original position
                    transition: {
                      duration: 1, // Animation duration
                      delay: 0.8,
                    },
                  }}
                // viewport={{ once: true }}
                >
                  <p>{parse(labelMobile)}</p>
                </motion.div>
              </Typography>
            </Box>
          </Box>


          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              mt: 4,
              [theme.breakpoints.down('lg')]: {
                mt: 0,
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '509px',
                height: '108px',
                mt: 10,
                [theme.breakpoints.down('lg')]: {
                  width: '360px !important',
                  height: '76px !important',
                  mt: 2,
                },
              }}
            >
              {/* <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                  },
                }}
              // viewport={{ once: true }}
              > */}
              <IconJadeSoftV2 />
              {/* </motion.div> */}
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              [theme.breakpoints.down('lg')]: {
                padding: '0 20px',
              },
            }}
          >
            <Typography
              variant="body1"
              sx={{
                wordWrap: 'break-word',
                fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '700',
                fontSize: '20px',
                mt: 3,
                lineHeight: '23.87px',
                color: '#000',
                [theme.breakpoints.down('lg')]: {
                  fontSize: '18px',
                  lineHeight: '23.4px',
                  textAlign: 'center',
                },
              }}
            >
              {/* <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                    delay: 0.8,
                  },
                }}
              // viewport={{ once: true }}
              > */}
              {parse(label2)}
              {/* </motion.div> */}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box className="homeContent">
        <Box
          // mt={15}
          mb={13}
          // display={'flex'}
          justifyContent={'center'}
          sx={{ maxWidth: '100%', maxHeight: '100%', color: '#000000' }}
        >
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0, lg: 15, xl: 15 }}
            spacing={3}
            sx={{
              marginTop: 'unset',
              [theme.breakpoints.down('lg')]: {
                marginTop: '80px',
              },
            }}
          >
            {HourIcon.map((item, index) => (
              <Grid item sx={{ justifyContent: 'center', display: 'flex' }} xs={12} sm={12} md={12} lg={6} xl={6} key={index} >
                <Box
                  sx={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    width: '697.5px',
                    // mt: 5,
                    justifyContent: 'center',
                    [theme.breakpoints.down('lg')]: {
                      mt: 5,
                    },
                  }}
                  display={'flex'}
                  key={item.id}
                >
                  <Box
                    sx={{
                      // backgroundColor: '#ffffff',
                      backgroundColor: '#F7F5F6',
                      textAlign: 'center',
                      // paddingLeft: 0,
                      // paddingRight: 0,
                      padding: '60px 125px',
                      maxHeight: '100%',
                      borderRadius: '10px',
                      boxShadow: '0px 4px 4px 0px #00000040',
                      [theme.breakpoints.down('lg')]: {
                        background: '#F7F5F6',
                        padding: '50px 20px',
                      },
                    }}
                  >
                    <Box>{item.image}</Box>
                    <Typography
                      variant="body1"
                      sx={{
                        mt: 4,
                        // mb: 7,
                        lineHeight: '19.09px',
                        wordWrap: 'break-word',
                        fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? 'unset' : '600',
                        fontSize: '16px',
                        color: '#000',
                        textAlign: 'center',
                        justifyContent: 'center',
                        [theme.breakpoints.down('lg')]: {
                          mt: 3,
                          fontSize: '18px',
                          lineHeight: '23.4px',
                        },
                      }}
                    >
                      {parse(item.content)}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Divider
          sx={{
            backgroundColor: '#21E418',
            color: '#21E418',
            width: '133px',
            height: '8px',
            justifySelf: 'center',
            marginBottom: 10,
          }}
        ></Divider>
        <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'center' }, zIndex: 1 }}>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: '48px',
              fontWeight: '700',
              mb: 4,
              color: '#000000',
              lineHeight: '57.28px',
              [theme.breakpoints.down('lg')]: {
                fontSize: '40px',
                lineHeight: '47.73px',
                display: 'none',
              },
            }}
          >
            <motion.div
              initial={{
                opacity: 0,
                y: 100,
              }}
              whileInView={{
                opacity: 1,
                y: 0, // Slide in to its original position
                transition: {
                  duration: 1, // Animation duration
                },
              }}
            // viewport={{ once: true }}
            >
              {parse(label1)}
            </motion.div>
          </Typography>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: '48px',
              fontWeight: '700',
              mb: 4,
              color: '#000000',
              lineHeight: '59.5px',
              display: 'none',
              [theme.breakpoints.down('lg')]: {
                fontSize: '40px',
                lineHeight: '47.73px',
                display: 'flex',
                textAlign: 'center',
                justifyContent: 'center',
              },
            }}
          >
            {parse(label1mobile)}
          </Typography>
          <Box sx={{
            padding: '0 30px', [theme.breakpoints.down('lg')]: {
              padding: '0 10px'
            }
          }}>
            <Typography
              variant="body1"
              sx={{
                wordWrap: 'break-word',
                fontWeight: 700,
                fontSize: '20px',
                color: '#000000',
                lineHeight: '23.87px',
                [theme.breakpoints.down('lg')]: {
                  fontSize: '18px',
                  lineHeight: '23.4px',
                  fontWeight: 600,
                },
              }}
            >
              <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                    delay: 0.8,
                  },
                }}
              // viewport={{ once: true }}
              >
                {parse(label3)}
              </motion.div>
            </Typography>
          </Box>
          <Box
            mt={5}
            mb={10}
            // px={12}
            display={'flex'}
            justifyContent={'center'}
            sx={{
              maxWidth: '100%',
              maxHeight: '100%',
              color: '#000000',
              [theme.breakpoints.down('lg')]: {
                mb: 0,
              },
            }}
          >
            {isMobile ? (
              <CarouselMobile />
            ) : (
              <Grid container spacing={2}>
                {iGamingSolutions.map((item, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    key={index}
                    sx={{
                      justifyItems: 'center',
                    }}
                  >
                    <Box sx={{ maxWidth: '100%', maxHeight: '100%', mt: 5 }} display={'flex'} key={item.id}>
                      <Box
                        sx={{
                          // backgroundColor: '#ffffff',
                          textAlign: 'center',
                          maxHeight: '100%',
                        }}
                      >
                        <Box
                          px={12}
                          sx={{
                            [theme.breakpoints.down('lg')]: {
                              width: '115px',
                              height: '114.88px',
                              display: 'flex',
                              justifyContent: 'center',
                              textAlign: 'center',
                              justifySelf: 'center',
                            },
                          }}
                        >
                          {item.image}
                        </Box>
                        <Box display={'flex'} justifyContent={'center'} px={8}>
                          <Typography
                            variant="body1"
                            sx={{
                              mt: 2,
                              mb: 2,
                              lineHeight: '25.42px',
                              wordWrap: 'break-word',
                              fontWeight: 800,
                              fontSize: '21.3px',
                              color: '#000000',
                              [theme.breakpoints.down('lg')]: {
                                mt: 1,
                                fontSize: '30px',
                                lineHeight: '35.8px',
                                color: '#000',
                              },
                            }}
                          >
                            {item.title}
                          </Typography>
                        </Box>
                        <Box px={1}>
                          <Typography
                            variant="body1"
                            sx={{
                              // mb: 4,
                              lineHeight: '20px',
                              // wordWrap: 'break-word',
                              fontWeight: 600,
                              fontSize: '16px',
                              color: '#000000',
                              lineHeight: '19.09px',
                              [theme.breakpoints.down('lg')]: {
                                fontSize: '18px',
                                lineHeight: '19.09px',
                                color: '#000',
                              },
                            }}
                          >
                            {parse(item.content)}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>
        </Box>
        <Divider
          sx={{
            backgroundColor: '#21E418',
            color: '#21E418',
            width: '133px',
            height: '8px',
            justifySelf: 'center',
            marginBottom: 10,
          }}
        ></Divider>
        <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'center' }, zIndex: 1 }}>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: '48px',
              fontWeight: '800',
              mb: 4,
              color: '#000000',
              lineHeight: '57.28px',
              [theme.breakpoints.down('lg')]: {
                fontSize: '40px',
                fontWeight: 800,
                lineHeight: '47.73px',
              },
            }}
          >
            {/* <motion.div
              initial={{
                opacity: 0,
                y: 100,
              }}
              whileInView={{
                opacity: 1,
                y: 0, // Slide in to its original position
                transition: {
                  duration: 1, // Animation duration
                },
              }}
            // viewport={{ once: true }}
            > */}
            {t('turnkey-header')}
            {/* </motion.div> */}
          </Typography>
          <Box
            sx={{
              padding: '0 30px',
              [theme.breakpoints.down('lg')]: {
                padding: 0,
              },
            }}
          >
            <Typography
              variant="body1"
              sx={{
                lineHeight: 1.8,
                wordWrap: 'break-word',
                fontWeight: 700,
                fontSize: '20px',
                color: '#000000',
                lineHeight: '23.87px',
                [theme.breakpoints.down('lg')]: {
                  fontSize: '18px',
                  lineHeight: '23.4px',
                  marginBottom: localStorage.getItem('i18nextLng') === 'en-US' ? '30px' : '40px',
                },
              }}
            >
              {/* <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                    delay: 0.8,
                  },
                }}
              // viewport={{ once: true }}
              > */}
              {parse(label4)}
              {/* </motion.div> */}
            </Typography>
          </Box>
          {/* <Box
            mt={5}
            mb={10}
            // px={12}
            display={'flex'}
            justifyContent={'center'}
            sx={{ maxWidth: '100%', maxHeight: '100%', color: '#000000' }}
          >
            <Grid container spacing={2}>
              {GameIcon.map((item, index) => (
                <Grid item xs={12} sm={12} md={12} lg={4} xl={4} key={index}>
                  <motion.div
                    initial={{
                      opacity: 0,
                      y: 100,
                    }}
                    whileInView={{
                      opacity: 1,
                      y: 0, // Slide in to its original position
                      transition: {
                        duration: 2, // Animation duration
                        delay: index * 0.8,
                      },
                    }}
                  // viewport={{ once: true }}
                  >
                    <Box
                      sx={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        mt: 5,
                        [theme.breakpoints.down('lg')]: {
                          mt: 2,
                        },
                      }}
                      display={'flex'}
                      key={item.id}
                    >
                      <Box
                        sx={{
                          // backgroundColor: '#ffffff',
                          textAlign: 'center',
                          maxHeight: '100%',
                        }}
                      >
                        <Box
                          px={6}
                          sx={{
                            [theme.breakpoints.down('lg')]: {
                              // width: '115px',
                              // height: '114.88px',
                              padding: 0,
                              display: 'flex',
                              justifyContent: 'center',
                              textAlign: 'center',
                              justifySelf: 'center',
                              width: '100% !important',
                            },
                          }}
                        >
                          <img
                            src={item.image}
                            style={{
                              // maxWidth: '100%',
                              width: '100%',
                              height: 'auto',
                              // objectFit: 'cover',
                            }}
                          />
                        </Box>
                        <Box display={'flex'} justifyContent={'center'} px={8}>
                          <Typography
                            variant="body1"
                            sx={{
                              mt: 2,
                              mb: 2,
                              lineHeight: '40.57px',
                              wordWrap: 'break-word',
                              fontWeight: 800,
                              fontSize: '34px',
                              color: '#000000',
                              [theme.breakpoints.down('lg')]: {
                                mt: 1,
                                fontSize: '40px',
                                lineHeight: '47.73px',
                                color: '#000000',
                              },
                            }}
                          >
                            {item.title}
                          </Typography>
                        </Box>
                        <Box sx={{
                          px: 6,
                          [theme.breakpoints.down('lg')]: {
                            px: 1,
                          },
                        }}>
                          <Typography
                            variant="body1"
                            sx={{
                              // mb: 4,
                              lineHeight: '23.87px',
                              // wordWrap: 'break-word',
                              fontWeight: 700,
                              fontSize: '20px',
                              color: '#000000',
                              [theme.breakpoints.down('lg')]: {
                                fontSize: '18px',
                                fontWeight: 700,
                                lineHeight: '23.4px',
                                color: '#000000',
                              },
                            }}
                          >
                            {parse(item.content)}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </Box> */}
        </Box>
      </Box>
    </StyledJadeSoftTeam>
  );
};

export default TurnKeySolution;
